import { render, staticRenderFns } from "./TncBlock.vue?vue&type=template&id=0ff30e14&"
import script from "./TncBlock.vue?vue&type=script&lang=js&"
export * from "./TncBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports